import styled from 'styled-components'

export const ContainerChart = styled.div`
  margin: 20px auto;
  max-width: 450px;
`;
